<div class="layout">

  <!-- TOPBAR -->
  <app-topbar (menuClick)="onMenuToggle()"></app-topbar>

  <!-- MOBILE OVERLAY -->
  <div
    (click)="onMenuToggle()"
    *ngIf="isSidebarOpen"
    class="overlay">
  </div>

  <div class="main">

    <!-- SIDEBAR -->
    <app-sidebar
      (close)="isSidebarOpen = false"
      [isOpen]="isSidebarOpen"
      class="sidebar">
    </app-sidebar>

    <!-- CONTENT -->
    <div class="content">
      <header class="page-header" *ngIf="pageTitle">
        <h1 class="page-title">{{ pageTitle }}</h1>
      </header>
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
